
import { OktaAuth } from '@okta/okta-auth-js'


export default async () => {
  // already loaded
  if (sessionStorage.getItem('oktaTokens')) {
    return true
  }

  const authClient = new OktaAuth({
    clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
    baseUrl: process.env.VUE_APP_OKTA_BASE_URL,
    issuer: process.env.VUE_APP_OKTA_ISSUER,
    redirectUri: window.origin + process.env.VUE_APP_OKTA_REDIRECT_SUFFIX,
    scopes: ['openid', 'profile', 'email', 'user_profile'],
    pkce: true,
    testing: {
      disableHttpsCheck: false,
    },
  }
  )
  const exists = await authClient.session.exists()
  if (exists) {
    const tokens = await authClient.token.getWithoutPrompt({
      responseType: 'id_token',
      sessionToken: 'testSessionToken'
    })
    sessionStorage.setItem('oktaTokens', JSON.stringify({
      accessToken: tokens.tokens.accessToken.accessToken,
      idToken: tokens.tokens.idToken.idToken
    }))
    return true
  }
  return false
}
